import {create} from 'zustand';

export type RegistrationPhase =
  | 'idle'
  | 'sending'
  | 'succeeded'
  | 'errored'
  | 'registered'
  | 'failed';

type RegistrationResultState = {
  phase: RegistrationPhase;
  firstName: string;
  setPhase: (phase: RegistrationPhase, firstName?: string) => void;
  reset: () => void;
};

export const useRegistrationResultStore = create<RegistrationResultState>(set => ({
  phase: 'idle',
  firstName: '',
  setPhase: (phase, firstName = '') => set({phase, firstName}),
  reset: () => set({phase: 'idle', firstName: ''}),
}));

export function isRegistrationResultShown(phase: RegistrationPhase) {
  return phase !== 'idle';
}

export function isRegistrationInFlight(phase: RegistrationPhase) {
  return phase === 'sending' || phase === 'succeeded' || phase === 'errored';
}
